import { render } from "./RecommendFoodItem.vue?vue&type=template&id=0fde0d54&scoped=true&ts=true"
import script from "./RecommendFoodItem.vue?vue&type=script&lang=ts"
export * from "./RecommendFoodItem.vue?vue&type=script&lang=ts"

import "./RecommendFoodItem.vue?vue&type=style&index=0&id=0fde0d54&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fde0d54"]])

export default __exports__